/** @jsxImportSource @emotion/react */
import { useState, useRef } from "react";
import { Column } from "primereact/column";
import { Menu } from "primereact/menu";
import { Boton, TablaFiltrable } from "../../shared";
import { Toast } from "primereact/toast";
import { CampoInformacion } from "../../shared";
import { downloadFile } from "../../shared";

export default function ProductoEnCertificado({
  productosCompletos,
  camposParaTabla,
  productosParaTabla,
}) {
  const [expandedRows, setExpandedRows] = useState(null);
  const menuRefs = useRef({});
  const toast = useRef(null);

  if (!camposParaTabla || !productosParaTabla) {
    return <p>No hay productos para mostrar</p>;
  }

  // Función para descargar etiqueta
  const descargarEtiqueta = (producto) => {
    if (producto.etiqueta && producto.etiqueta.length > 0) {
      const etiqueta = producto.etiqueta[0];
      const nombreArchivo =
        etiqueta.archivo?.nombredescarga || "etiqueta.pdf";

      downloadFile(
        `cliente/instanciacertificado/descargaretiqueta/${etiqueta.id}`,
        nombreArchivo,
        () => {
          // Success
        },
        (error) => {
          if (toast.current) {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: error[0]?.msg || "No se pudo descargar la etiqueta",
              sticky: true,
            });
          }
        }
      );
    }
  };

  // Template para la columna de acciones
  const actionBodyTemplate = (data, options) => {
    const producto = productosCompletos[options.rowIndex];

    // Solo mostrar el menú si el producto tiene etiqueta
    if (!producto || !producto.etiqueta || producto.etiqueta.length === 0) {
      return null;
    }

    const items = [
      {
        label: "Descargar etiqueta",
        icon: "pi pi-download",
        command: () => descargarEtiqueta(producto),
      },
    ];

    return (
      <div>
        <Menu
          model={items}
          popup
          ref={(el) => (menuRefs.current[producto.id] = el)}
          id={`popup_menu_${producto.id}`}
        />
        <Boton
          callback={(event) => menuRefs.current[producto.id]?.toggle(event)}
          icono
          chico
          negro
        >
          <i className="pi pi-ellipsis-v"></i>
        </Boton>
      </div>
    );
  };

  // Template para el contenido expandido de cada fila
  const rowExpansionTemplate = (data, options) => {
    // Encontrar el producto completo usando el índice de la fila
    const productoCompleto = productosCompletos[options.index];

    if (!productoCompleto) {
      return <p>No hay información adicional</p>;
    }

    return (
      <div
        css={{
          padding: "1em",
          backgroundColor: "#f8f9fa",
          borderRadius: "6px",
        }}
      >
        <div className="grid">
          {productoCompleto.producto_x_productocampospropios.map((campo) => (
            <CampoInformacion
              key={campo.id}
              nombreCampo={campo.productocampospropios.etiqueta}
            >
              {campo.valor
                ? `${campo.valor}${campo.productocampospropios?.unidades ? ` ${campo.productocampospropios.unidades}` : ""}`
                : "N/A"}
            </CampoInformacion>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div>
      <Toast ref={toast} position="top-center" />
      <TablaFiltrable conFiltros={false}
        value={productosParaTabla}
        emptyMessage="No hay productos cargados"
        stripedRows
        size="small"
        expandedRows={expandedRows}
        onRowToggle={(e) => setExpandedRows(e.data)}
        rowExpansionTemplate={rowExpansionTemplate}
      >
        <Column expander style={{ width: "3em" }} />
        {Object.entries(camposParaTabla).map((campo) => {
          return (
            <Column key={campo[0]} field={campo[0]} header={campo[1]}></Column>
          );
        })}
        <Column
          body={actionBodyTemplate}
          style={{ width: "3em", textAlign: "center" }}
        />
      </TablaFiltrable>
    </div>
  );
}
